export const DRAG = 'drag';
export const HOVER = 'hover';
export const SELECTIONDRAG = 'selectiondrag';
export const CLICK = 'click';
export const LONGTOUCH = 'longtouch';
export const TOUCHDRAG = 'touchdrag';
export const ALL_ACTIONS = '*';
